module.exports = __webpack_public_path__ + "b9ff955c10cd67ffbf93d8f5841eab84.pdf";